import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Check } from "lucide-react";
import { MENTORSHIP } from "../../data";
import { Reveal, Kicker } from "./Reveal";

export default function Mentorship() {
  const [active, setActive] = useState(0);
  const m = MENTORSHIP[active];
  return (
    <section id="mentorship-section" data-testid="mentorship-section" className="py-24 lg:py-36 bg-sand">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <Reveal><Kicker>The Program</Kicker></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl text-ink tracking-tight leading-[1.08]">Evolutionary mentorship, not just money</h2>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-14">
          <div className="lg:col-span-4 flex flex-col gap-2">
            {MENTORSHIP.map((t, i) => (
              <button key={t.key} data-testid="mentorship-tab-button" onClick={() => setActive(i)}
                className={`text-left rounded-2xl px-6 py-5 border transition-all duration-300 ${active === i ? "bg-ink text-sand border-ink" : "bg-cardw text-ink border-borderln hover:border-gold"}`}>
                <span className={`text-xs font-mono mr-3 ${active === i ? "text-brass" : "text-bronze"}`}>0{i + 1}</span>
                <span className="font-serif text-xl">{t.tab}</span>
              </button>
            ))}
          </div>

          <div className="lg:col-span-8">
            <AnimatePresence mode="wait">
              <motion.div key={m.key} data-testid="mentorship-content-panel"
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                className="h-full rounded-3xl border border-borderln bg-cardw p-8 sm:p-12">
                <h3 className="font-serif text-3xl text-ink">{m.tab}</h3>
                <p className="mt-4 text-lg text-stoneink leading-relaxed max-w-2xl">{m.body}</p>
                <ul className="mt-8 space-y-3">
                  {m.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-ink">
                      <span className="w-6 h-6 rounded-full bg-gold/15 flex items-center justify-center"><Check className="w-3.5 h-3.5 text-bronze" /></span>
                      {p}
                    </li>
                  ))}
                </ul>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
